module.exports = {"StatusCode":200,"Payload":"[{\"stripe\":{\"subscriptionId\":\"sub_FKSu8yt3QwlkPB\"},\"cloudWatchEvents\":[],\"sslRequests\":[]}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/applyDiscount.json
// module id = J6wh
// module chunks = 0